import React from "react";
import { Modal, Button } from "react-bootstrap";
import { formatDistanceToNow } from "date-fns";

const VehicleAttendanceHistoryDetailModal = ({ show, onHide, data }) => {
  if (!data) return null;
  const formatDate = (date) => {
    if (!date) return "N/A";
    const options = { year: "numeric", month: "long", day: "numeric" };
    return new Date(date).toLocaleDateString(undefined, options);
  };
  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Vehicle Attendance History Details</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          <strong>Date:</strong> {data.date}
        </p>

        <p>
          <strong>Vehicle Number:</strong> {data.numberplate}
        </p>

        <p>
          <strong>Daily KM:</strong> {Number(data.dailyKm || 0).toFixed(2)}
        </p>

        <p>
          <strong>Model:</strong> {data.model}
        </p>

        <p>
          <strong>Hub:</strong> {data.hub}
        </p>

        <p>
          <strong>Created At:</strong>{" "}
          {new Date(data.createdAt).toLocaleString()}
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default VehicleAttendanceHistoryDetailModal;
